import React from 'react';
import { useUID } from 'react-uid';
/**
 * useId
 * @returns either the React v18 useId hook if provided (v18+), or a fallback for versions 16-17
 *
 * Note that react-uid's useUID can generate mismatching ids between the server- and client-side renders,
 * but React didn't introduce the useId hook until v18, and no better solution for v16-17 is workable.
 */
export const useId = () => 
// Couldn't find an alternative, so suppressing the rule.
// eslint-disable-next-line react-hooks/rules-of-hooks
React.useId && typeof React.useId === 'function' ? React.useId() : useUID();
